import axios from "axios";

const { REACT_APP_GENNEV_API_URL } = process.env;

class GennevApiService {
  baseUrl = REACT_APP_GENNEV_API_URL;

  constructor() {
    const headers = {
      "Content-Type": "application/json",
    };

    this.client = axios.create({
      baseURL: REACT_APP_GENNEV_API_URL,
      headers,
    });

    const token = localStorage.getItem("token");
    if (token) {
      this.setToken(token);
    }
  }

  login(username, password) {
    // remove existing token
    this.removeToken();
    return this.client
      .post("/user/auth/login", { email: username, password })
      .then((response) => response.data);
  }

  refreshToken(refreshToken) {
    this.removeToken();
    return this.client
      .post("/user/auth/token", { refresh_token: refreshToken })
      .then((response) => response.data);
  }

  setToken(token) {
    this.token = token;
    this.client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }

  removeToken() {
    this.token = null;
    delete this.client.defaults.headers.common["Authorization"];
  }

  /** USER API */
  me() {
    return this.client.get("/admin/user/me").then((response) => response.data);
  }

  impersonate(userId) {
    return this.client
      .post(`/admin/user/${userId}/impersonate`)
      .then((response) => response.data);
  }

  getUser(userId) {
    return this.client
      .get(`/admin/user/${userId}`)
      .then((response) => response.data);
  }

  getFilteredUsers({ filter, range, sort }) {
    return this.client
      .get(`/admin/user`, {
        params: {
          filter: JSON.stringify(filter),
          sort: JSON.stringify(sort),
          range: JSON.stringify(range),
        },
      })
      .then((response) => response.data);
  }

  createUser(data) {
    return this.client
      .post(`/admin/user`, data)
      .then((response) => response.data);
  }

  updateUser(userId, data) {
    return this.client
      .put(`/admin/user/${userId}`, data)
      .then((response) => response.data);
  }
  deleteUser(id) {
    return this.client
      .delete(`/admin/user/${id}`)
      .then((response) => response.data);
  }
  getStates() {
    return this.client.get("/geo/states").then((response) => response.data);
  }

  getCities(stateId) {
    return this.client
      .get(`/geo/states/${stateId}/cities`)
      .then((response) => response.data);
  }

  getUserStats(start, end) {
    return this.client
      .get("/admin/user/stats", {
        params: {
          start,
          end,
        },
      })
      .then((response) => response);
  }

  getMedicalAppointmentStats(start, end) {
    return this.client
      .get("/admin/medical/stats/appointment", {
        params: {
          start,
          end,
        },
      })
      .then((response) => response);
  }

  resetPassword(email) {
    return this.client
      .post("/user/auth/reset-password", { email })
      .then((response) => response);
  }

  setPassword(userId, password) {
    return this.client
      .post(`/user/${userId}/change-password`, { password })
      .then((response) => response);
  }

  reindex(collection) {
    return this.client
      .get(`/admin/algolia/reindex/${collection}`)
      .then((response) => response);
  }
}

export const extractResourceParams = (resource) => {
  const pattern = /(\D+)(\d+)(.*)/;
  const matches = resource.match(pattern);
  if (!matches) {
    return { normalizedResource: resource, urlParams: [] };
  }

  const normalizedResource = resource.replace(pattern, "$1:id$3");
  return { normalizedResource, urlParams: [matches[2]] };
};

export const paginationToParamsConverter = (params) => {
  if (!params) return {};
  const { page, perPage } = params.pagination;
  const { field, order } = params.sort;

  const rangeStart = (page - 1) * perPage;
  return {
    filter: params.filter,
    sort: [field, order],
    range: [rangeStart, perPage],
  };
};

export default new GennevApiService();
